import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const linkCls = ({ isActive }) =>
  `text-sm transition-colors ${isActive ? "text-[var(--ink)]" : "text-[var(--ink-2)] hover:text-[var(--ink)]"}`;

export const SiteNav = () => {
  const { user, signOut } = useAuth();
  return (
    <header className="sticky top-0 z-40 border-b border-[var(--rule)] bg-[var(--paper)]/85 backdrop-blur-md">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="w-7 h-7 bg-[var(--ink)] text-[var(--paper)] grid place-items-center font-serif-d text-lg leading-none">P</span>
          <span className="font-serif-d text-xl tracking-tight" data-testid="nav-brand-name">PDF Review</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/playbooks" className={linkCls} data-testid="nav-playbooks">Use Cases</NavLink>
          {user && <NavLink to="/history" className={linkCls} data-testid="nav-history">History</NavLink>}
        </nav>
        <div className="flex items-center gap-5">
          {user ? (
            <>
              <span className="hidden sm:inline font-mono-d text-xs text-[var(--ink-3)]" data-testid="nav-user-email">{user.email}</span>
              <button onClick={signOut} className="text-sm text-[var(--ink-2)] hover:text-[var(--ink)]" data-testid="nav-logout-btn">Sign out</button>
            </>
          ) : (
            <Link to="/login" className="text-sm text-[var(--ink-2)] hover:text-[var(--ink)]" data-testid="nav-login-link">Sign in</Link>
          )}
          <Link to="/new" className="btn-ink text-sm font-medium px-5 py-2.5" data-testid="nav-start-review-btn">New review</Link>
        </div>
      </div>
    </header>
  );
};
